"use client";

export default function FloatingCall() {
  return (
    <a
      href="tel:+48661709414"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-blue-600 hover:bg-blue-500 active:bg-blue-700 text-white px-5 py-3.5 rounded-full shadow-lg shadow-blue-600/30 transition-all hover:scale-105"
      aria-label="Zadzwoń teraz"
    >
      <span className="text-xl">☎</span>
      <span className="font-semibold hidden sm:inline">661 709 414</span>
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-400 rounded-full animate-pulse" />
    </a>
  );
}
